import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Copy, Check, ArrowRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];
const CODE = "DJLIFE";
const AMOUNT = "€49.99";
const SITE_URL = "https://suru.music/register";

const rise = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 1.1, ease: EASE, delay: 0.15 + i * 0.14 } }),
};

const track = async (event) => {
  try {
    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event }),
    });
  } catch (e) {}
};

export default function CouponSlide() {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    document.title = "Suruverse";
    if (!sessionStorage.getItem("suru_page_view_tracked")) {
      sessionStorage.setItem("suru_page_view_tracked", "1");
      track("page_view");
    }
  }, []);
  const copy = async () => {
    try { await navigator.clipboard.writeText(CODE); setCopied(true); track("copy_code"); setTimeout(() => setCopied(false), 2000); }
    catch (e) { setCopied(false); }
  };
  return (
    <div className="relative flex h-screen w-screen flex-col items-center justify-center overflow-hidden bg-[#0E100E] px-6 text-center" data-testid="coupon-slide">
      <img src="/bowls.webp" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center opacity-20" />
      <div className="absolute inset-0 bg-[#0E100E]/82" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0E100E] via-[#0E100E]/70 to-[#0E100E]/60" />
      <div className="relative z-10 flex w-full max-w-xl flex-col items-center">
        <motion.img src="/suru-logo.webp" alt="Suru" className="h-20 w-auto object-contain opacity-95 md:h-24" variants={rise} initial="hidden" animate="show" custom={0} />
        <motion.div variants={rise} initial="hidden" animate="show" custom={1} className="mt-8">
          <span style={{ fontFamily: "Outfit, sans-serif" }} className="text-[11px] font-light uppercase tracking-[0.34em] text-[#A6B39B]">DJ Philosophy · Timo Maas & Dan (Pig&amp;Dan)</span>
        </motion.div>
        <motion.h1 style={{ fontFamily: "Outfit, sans-serif" }} variants={rise} initial="hidden" animate="show" custom={2} className="mt-7 text-3xl font-extralight leading-[1.2] tracking-[0.1em] text-white sm:text-4xl md:text-5xl">A thank-you for tonight.</motion.h1>
        <motion.p variants={rise} initial="hidden" animate="show" custom={3} className="mt-6 max-w-md text-[15px] font-light leading-loose tracking-wide text-white/60">For everyone in tonight’s session — a little something to begin your journey inside Suruverse.</motion.p>
        <motion.button onClick={copy} variants={rise} initial="hidden" animate="show" custom={4} data-testid="copy-code-btn" className="group mt-12 flex w-full max-w-sm items-center justify-between gap-4 rounded-2xl border border-dashed border-white/25 bg-white/[0.03] px-7 py-6 transition-colors duration-500 hover:border-[#A6B39B]/60">
          <span className="text-left">
            <span style={{ fontFamily: "Outfit, sans-serif" }} className="block text-[10px] font-light uppercase tracking-[0.34em] text-white/40">Your code</span>
            <span style={{ fontFamily: "Outfit, sans-serif" }} className="mt-2 block text-3xl font-light tracking-[0.28em] text-white md:text-4xl" data-testid="coupon-code">{CODE}</span>
          </span>
          <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-300 group-hover:bg-[#73806C] group-hover:border-[#73806C]">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </span>
        </motion.button>
        <motion.p variants={rise} initial="hidden" animate="show" custom={5} className="mt-6 text-xs font-light uppercase tracking-[0.28em] text-[#A6B39B]">Up to {AMOUNT} off · once per customer</motion.p>
        <motion.a href={SITE_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("register_click")} variants={rise} initial="hidden" animate="show" custom={6} className="group mt-12 inline-flex items-center gap-3 border border-white/50 px-10 py-4 text-sm font-light uppercase tracking-[0.28em] text-white transition-colors duration-500 hover:border-[#A6B39B] hover:bg-[#73806C] hover:text-white">Register &amp; apply the code<ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" /></motion.a>
        <motion.p variants={rise} initial="hidden" animate="show" custom={7} className="mt-10 text-[11px] font-light uppercase tracking-[0.3em] text-white/35">Enter {CODE} at checkout</motion.p>
      </div>
    </div>
  );
}
